var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"content"},[(_vm.showStepper)?_c('RegisterStepper',{attrs:{"baseInfo":_vm.baseInfo,"year":_vm.year,"code":_vm.code,"symbol":_vm.symbol,"substrate":_vm.substrate,"referrer":_vm.referrer}}):_c('NameRegister',{attrs:{"baseInfo":_vm.baseInfo},on:{"confirm":_vm.handlerConfirm}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }